import React, {useEffect, useState} from 'react';
import {Rate, Modal, Dropdown} from 'antd';
import {CheckIcon, XIcon, MenuIcon, ChatIcon} from '../SvgIcons/SvgIcons';
import PurchaseModal from './PurchaseModal';
import DeclineModal from './DeclineModal';
import MarkCompleteModal from './MarkCompleteModal';
import CancelIntro from './CancelIntro';
import {useHistory} from 'react-router-dom';

const BountyOfferCard = ({
  offer,
  bountyId,
  fullName,
  setOfferId,
  demandPrice,
  company,
  bountyType
}) => {
  const [setModal, setModalVisible] = useState(false);
  const [setModal2, setModalVisible2] = useState(false);
  const [setModal3, setModalVisible3] = useState(false);
  const history = useHistory();
  const showPurchaseModal = () => {
    setModalVisible(true);
  };
  const handlePurchase = () => {
    setModalVisible(false);
  };
  const cancelPurchase = () => {
    setModalVisible(false);
  };
  const showDeclineModal = () => {
    setModalVisible2(true);
  };
  const handleDecline = () => {
    setModalVisible2(false);
  };
  const cancelDecline = () => {
    setModalVisible2(false);
  };

  const handleCompleteModal = () => {
    setModalVisible3(true);
  };

  const cancelComplete = () => {
    setModalVisible3(false);
  };

  const {
    introPerson: {firstName, lastName, rating},
    introTime,
    relation,
    comment,
    id,
    status,
  } = offer;

  useEffect(() => {
    setOfferId(id);
  }, [id]);

  const [dropDownVisible, setDropDownVisible] = useState(false);

  const handleVisible = () => {
    setDropDownVisible(true);
  };

  const handleVisibleCancel = () => {
    setDropDownVisible(false);
  };

  return (
    <div className="bounty-offer-card">
      <div className="offer-card-top">
        <h2 className="small-heading">
          @{firstName}
          {lastName}
        </h2>
        <Rate style={{color: '#000'}} value={rating} />
      </div>
      <div className="delivery-info-wrap">
        <div className="info-wrap">
          <span>Relationship</span>
          <h3 className="paragraph">{relation}</h3>
        </div>
        <div className="info-wrap">
          <span>Deliver by</span>
          <h3 className="paragraph">Intro {introTime}</h3>
        </div>
        <div className="info-wrap col p-0">
          <span>Comments</span>
          <h3 className="paragraph">{comment}</h3>
        </div>
      </div>
      {status === 'accepted' ? (
        <div className="btn-row">
          <div className="col p-0">
            <button className="btn-style" onClick={() => history.push(`/chat`)}>
              <ChatIcon />
              Arrange intro
            </button>
          </div>
          <div className="col p-0">
            <button className="btn-style" onClick={handleCompleteModal}>
              <CheckIcon />
              Mark completed
            </button>
          </div>
          <div className="more-btn">
            <Dropdown
              visible={dropDownVisible}
              onVisibleChange={() => handleVisible()}
              overlay={
                <CancelIntro
                  firstName={firstName}
                  lastName={lastName}
                  handleVisibleCancel={handleVisibleCancel}
                  offerId={id}
                />
              }
              placement="bottomRight"
              trigger={['click']}>
              <button className="btn-style">
                <MenuIcon />
              </button>
            </Dropdown>
          </div>
        </div>
      ) : status === 'hold' ? (
        <div className="btn-row">
          <div className="col p-0">
            <button
              disabled={true}
              className="btn-style"
              onClick={showDeclineModal}>
              <XIcon />
              Decline intro
            </button>
          </div>
          <div className="col p-0">
            <button
              disabled={true}
              className="btn-style"
              onClick={showPurchaseModal}>
              <CheckIcon />
              Purchase intro
            </button>
          </div>
        </div>
      ) : (
        <div className="btn-row">
          <div className="col p-0">
            <button className="btn-style" onClick={showDeclineModal}>
              <XIcon />
              Decline intro
            </button>
          </div>
          <div className="col p-0">
            <button className="btn-style" onClick={showPurchaseModal}>
              <CheckIcon />
              Purchase intro
            </button>
          </div>
        </div>
      )}

      <Modal
        visible={setModal}
        onOk={handlePurchase}
        onCancel={cancelPurchase}
        footer={null}
        closable={false}
        className="modal-body">
        <PurchaseModal
          firstName={firstName}
          lastName={lastName}
          fullName={fullName}
          bountyId={bountyId}
          offerId={id}
          handleCancel={cancelPurchase}
          status={status}
          company={company}
          demandPrice={demandPrice}
          bountyType={bountyType}
        />
      </Modal>
      <Modal
        visible={setModal2}
        onOk={handleDecline}
        onCancel={cancelDecline}
        footer={null}
        closable={false}
        className="modal-body">
        <DeclineModal
          firstName={firstName}
          lastName={lastName}
          fullName={fullName}
          bountyId={bountyId}
          offerId={id}
          handleCancel={cancelDecline}
          company={company}
          bountyType={bountyType}
        />
      </Modal>
      <Modal
        visible={setModal3}
        onOk={handleCompleteModal}
        onCancel={cancelComplete}
        footer={null}
        closable={false}
        className="modal-body">
        <MarkCompleteModal
          firstName={firstName}
          lastName={lastName}
          fullName={fullName}
          offerId={id}
          handleCancel={cancelComplete}
          company={company}
          bountyType={bountyType}
        />
      </Modal>
    </div>
  );
};

export default BountyOfferCard;
